// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'

// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
// import VTooltip from 'v-tooltip'
import App from './App'

/* Use */
Vue.use(Vuex);
Vue.use(BootstrapVue);
// Vue.use(VTooltip);


// components
import UXInput from './components/input/UXInput'
import UXButton from './components/button/UXButton'
import UXBadge from './components/badge/UXBadge'
import UXRiskBar from './components/risk-bar/UXRiskBar'
import UXPdfButton from './components/pdf-button/UXPdfButton'
import UXRadioButton from './components/radio-button/UXRadioButton'
import UXPreviewCard from './components/preview-card/UXPreviewCard'
import UXModifierField from './components/modifier-field/UXModifierField'
import UXRiskCircle from './components/risk-circle/UXRiskCircle'
import UXMultiselectSingle from './components/multiselect-single/UXMultiselectSingle'
import UXMultiselectMultiple from './components/multiselect-multiple/UXMultiselectMultiple'
import UXModalNav from './components/modal-nav/UXModalNav'
import UXFolderHeader from './components/folder-header/UXFolderHeader';
import UXFolderFileDocument from './components/folder-file-document/UXFolderFileDocument';
import UXFolderFileImage from './components/folder-file-image/UXFolderFileImage';
import UXFolderQuestion from './components/folder-question/UXFolderQuestion';
import UXFolderContentContainer from './components/folder-content-container/UXFolderContentContainer';
import UXSmallFormFactorFolderContentContainer from './components/small-form-factor-folder-content-container/UXSmallFormFactorFolderContentContainer';
import UXStepProgressIndicator from './components/step-progress-indicator/UXStepProgressIndicator';
import VueGallery from 'vue-gallery';


Vue.component('ux-input', UXInput);
Vue.component('ux-button', UXButton);
Vue.component('ux-badge', UXBadge);
Vue.component('ux-risk-bar', UXRiskBar);
Vue.component('ux-pdf-button', UXPdfButton);
Vue.component('ux-radio-button', UXRadioButton);
Vue.component('ux-preview-card', UXPreviewCard);
Vue.component('ux-modifier-field', UXModifierField);
Vue.component('ux-risk-circle', UXRiskCircle);
Vue.component('ux-multiselect-single', UXMultiselectSingle);
Vue.component('ux-multiselect-multiple', UXMultiselectMultiple);
Vue.component('ux-modal-nav', UXModalNav);
Vue.component('ux-folder-header', UXFolderHeader);
Vue.component('ux-folder-file-document', UXFolderFileDocument);
Vue.component('ux-folder-file-image', UXFolderFileImage);
Vue.component('ux-folder-question', UXFolderQuestion);
Vue.component('ux-folder-content-container', UXFolderContentContainer);
Vue.component('ux-small-form-factor-folder-content-container', UXSmallFormFactorFolderContentContainer);
Vue.component('ux-step-progress-indicator', UXStepProgressIndicator);
Vue.component('vue-gallery', VueGallery);


// Router
import router from './router/index'

// Vuex
import vuexBasic from './vuex/basic'
import vuexFile from './vuex/filebrowser'


// Vuex store
const store = new Vuex.Store({
  modules: {
    basic: vuexBasic,
    documents: vuexFile
  }
});



/*   eslint-disable no-new   */
/*   eslint-disable no-undef   */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  data: {'config_': null},
  created() {
    if (typeof (config_) != "undefined") {
      this.config_ = config_;
    }
  },
  components: {
    App
  }
});
